import { render, staticRenderFns } from "./tabbar-travel.vue?vue&type=template&id=1759f470&scoped=true"
import script from "./tabbar-travel.vue?vue&type=script&lang=js"
export * from "./tabbar-travel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1759f470",
  null
  
)

export default component.exports